/** Copyright 2024 Midas Healthcare Solutions - All Rights Reserved **/

export interface UserNotification {
  notificationType: NotificationType;
  sendEmail: boolean;
  sendText: boolean;
}

export enum NotificationType {
  BinCapacity = 0,
  RxInterceptBoxCapacity = 1,
  StalePendingWaste = 2,
  StalePendingTransport = 3,
  AbandonedWaste = 4,
  AbandonedTransport = 5,
}
